module.exports = "pegasus/assets/blocks/column-6-theme5.png";